// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartGridPivot.jsx" company="Izenda">  Copyright
// (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import AppGlobal from 'Izenda.AppGlobal';
import { get } from 'lodash/fp';
import connect from 'share/enhancers/Izenda.Connect';
import reportPartUtils from 'share/utils/Izenda.ReportPartUtils';
import ColumnDataObject from 'logic/models/Izenda.ColumnDataObject';
import ProcessData from 'logic/Izenda.ReportPartGridProcessData';
import calculatedFieldConstants from 'logic/data/Izenda.CalculatedFieldConstants';

/**
 * Component which render sub total cell.
 */
@connect()
export default class SubTotalCell extends Component {

  render() {
    const {props} = this;
    const {localization, rowData, columnData, subTotalMapping, rowExpanders,
      forDrillDown, fieldElement, isDisplayCell} = props;

    const value = ProcessData.getDataForCell(columnData, rowData, rowExpanders, forDrillDown, subTotalMapping);
    const alternativeText = get('properties.dataFormattings.alternativeText', fieldElement);
    const dataFormattings = get('element.properties.dataFormattings', columnData);
    const fieldFormat = get('format.format', dataFormattings);
    const subTotalFormat = get('subTotal.format.format', dataFormattings);
    const subTotalFont = get('subTotal.font', dataFormattings);
    const previewDataType = get('previewDataType', fieldElement);

    const formattedValueData = reportPartUtils.getDataFormat(
      value.data,
      {
        alternativeText: alternativeText,
        fieldFormatData: subTotalFormat || fieldFormat,
        fieldDataType: previewDataType
      }
    );

    if (!value.isEmpty || isDisplayCell) {
      const {subTotal} = dataFormattings;
      
      const renderSubTotalCellValue = () => {
        let value = formattedValueData;
        if(forDrillDown && columnData.type === ColumnDataObject.COLUMN_TYPE.ROW)
            value = String.format(localization.getText('REPORTDESIGNER_LABEL_TOTAL_FOR'), formattedValueData);
        if(AppGlobal.isRenderHtmlInReportViewer())
          value = (<span dangerouslySetInnerHTML={{__html: value}}></span>);
        return value; 
      }

      const getContentCellStyle = (subTotalFont: any) => {
        if (!subTotalFont) {
          return {};
        }
      
        return {
          fontWeight: (subTotalFont.bold !== undefined) ? (subTotalFont.bold ? 'bold' : 'normal') : (calculatedFieldConstants.DEFAULT_VALUE_PROPERTIES.SUB_TOTAL.FONT.BOLD ? 'bold' : 'normal'),
          fontStyle: subTotalFont.italic ? 'italic' : 'normal',
          textDecoration: subTotalFont.underline ? 'underline' : 'none',
          fontFamily:(subTotalFont.family !== undefined) ? subTotalFont.family : calculatedFieldConstants.DEFAULT_VALUE_PROPERTIES.FONT.FAMILY,
          fontSize: (subTotalFont.size ? subTotalFont.size: calculatedFieldConstants.DEFAULT_VALUE_PROPERTIES.FONT.SIZE)  + 'px',
          // backgroundColor: subTotalFont.backgroundColor ? subTotalFont.backgroundColor : calculatedFieldConstants.DEFAULT_VALUE_PROPERTIES.FONT.BACKGROUND_COLOR,
          color: subTotalFont.color ? subTotalFont.color : calculatedFieldConstants.DEFAULT_VALUE_PROPERTIES.FONT.COLOR
        };
      };
      const cellStyle = getContentCellStyle(subTotalFont);
      return (
        <span className="sub-total" title={subTotal.label} style={cellStyle}>
          {renderSubTotalCellValue()}
        </span>
      );
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartGrid/Izenda.SubTotalCell.js